import React from 'react';
import { useRegistrationPayment } from '../lib/useRegistrationPayment';
import RegistrationIntro from './RegistrationIntro';
import RegistrationForm from './RegistrationForm';
import RegistrationSuccess from './RegistrationSuccess';

export default function Registration() {
  const { form, loading, error, success, updateField, pay, reset } = useRegistrationPayment();

  if (success) {
    return <RegistrationSuccess success={success} onRegisterAnother={reset} />;
  }

  return (
    <section id="register" className="py-16 lg:py-24 bg-gradient-to-b from-[#FFF8EC] to-[#F4B93E]/25">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-10 items-start">
        <RegistrationIntro />
        <div className="lg:col-span-7">
          <RegistrationForm
            form={form}
            updateField={updateField}
            onSubmit={pay}
            loading={loading}
            error={error}
          />
        </div>
      </div>
    </section>
  );
}
